import { GlobalStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';
//
import { workspaceCanvasOf } from 'src/theme/universe/brand';

// ---------------------------------------------------------------------------
// THE GROUND OF A WORKSPACE PAGE (DESIGN.md §7): a step deeper than the
// portal's canvas, painted only while the workspace is mounted, so the region
// sheets stand off it (the owner, 08/10/2026: "still melted with the bg").
// The layout's <main> paints the portal canvas through its own class, so the
// rule names the tag with an attribute to outrank it; a harness has no <main>
// and paints its body instead. Shared by every workspace that wears the
// Universe skin (the translation and the event pages).
// ---------------------------------------------------------------------------

export default function WorkspaceCanvas() {
  const theme = useTheme();
  const canvas = workspaceCanvasOf(theme);
  return <GlobalStyles styles={{ 'main[class], body': { backgroundColor: canvas } }} />;
}
